import { render } from "./FormRender.html?vue&type=template&id=32baf146&scoped=true&ts=true"
import script from "./FormRender.ts?vue&type=script&lang=ts"
export * from "./FormRender.ts?vue&type=script&lang=ts"

import "./FormRender.scss?vue&type=style&index=0&id=32baf146&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32baf146"]])

export default __exports__